import { PayMCopyDateLogTypeKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate/payMCopyDateLog'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import { ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { displayDate } from '../../../../../../utils/globals/date'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalLogsPaymentMethodDateProps extends ModalEditComponentProps {
}

const ModalLogsPaymentMethodDate: React.FC<ModalLogsPaymentMethodDateProps> = ({ setOpened, allRowData }) => {
    const renderThis: JSX.Element[] = []
    const { t, tVars } = useTwinTranslation()
    if (allRowData?.PayMDateCopyLogs?.length) {
        for (const log of allRowData?.PayMDateCopyLogs) {
            const extraDataParsed = JSON.parse(log?.extraData || '{}')
            const options = { employeeTrigger: log?.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log?.createdAt)), newDate: displayDate(new Date(extraDataParsed?.newDate)), fullAssignedNumber: extraDataParsed?.full_assigned_number || '', 'interpolation': { 'escapeValue': false }, }
            let extraInfo = extraDataParsed?.SplittedOf ? ' ' + t('fromDivisionPayment', 'de la división de un pago.') : extraDataParsed?.Grouped ? ' ' + t('fromGroupedPayment', 'de la agrupación de varios pagos') : ''
            const dictLogsMessages: Record<PayMCopyDateLogTypeKeys, string> = {
                1: tVars('createPaymentMethodDateMessageNoEmployee', 'creó este pago el {{date}}', options) + extraInfo,
                2: tVars('changeStatusPaymentMethodDateMessageNoEmployee', 'cambió el estado de este pago el {{date}}', options),
                3: tVars('changeDatePaymentMethodDateMessageNoEmployee', 'cambió la fecha a {{newDate}} de este pago el {{date}}', options),
                4: tVars('changePaymentTypePaymentMethodDateMessageNoEmployee', 'cambió el tipo de pago el {{date}}', options),
                5: tVars('changeExtraPaymentDataPaymentMethodDateMessageNoEmployee', 'cambió la información de este pago el {{date}}', options),
                6: tVars('paymentMethodDateGroupedMessageNoEmployee', 'ha agrupado este pago el {{date}}', options),
                7: tVars('paymentMethodDateDividedMessageNoEmployee', 'ha dividido este pago el {{date}}', options)
            }
            const message = dictLogsMessages?.[log?.type as PayMCopyDateLogTypeKeys]
            renderThis.push(<div key={log.id} className='text-start'>
                <span className='link14 text-gray-51'>{log?.EmployeeTrigger?.fullname_short} </span>
                <span className='label14'>{message}</span>
            </div>)
        }
    }
    renderThis.reverse()
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} className='flex_height'>
            <h2><TwinTrans transKey='logsPaymentMethodDate'>Historial de este pago</TwinTrans></h2>
            <div className='flex flex-col items-start justify-start gap-y-10 overflow-auto my-10'>
                {renderThis}
            </div>
            <div className='flex justify-center mt-10'>
                <ButtonSecondary onClick={() => setOpened(null)}><TwinTrans transKey='return'>Volver</TwinTrans></ButtonSecondary>
            </div>
        </ModalSmallCentered>
    )
}

export default ModalLogsPaymentMethodDate